import React from 'react';
import {Box} from "@mui/material"
import {Outlet} from "react-router-dom"
import {TOP_NAV_HEIGHT, CONTENT_BG} from "./layoutConstants"

function AccountContainer() {
    return (
        <Box sx={{
            mt: `${TOP_NAV_HEIGHT}px`,
            pt: 4,
            pb: 10,
            px: 6,
            minHeight: `calc(100vh - ${TOP_NAV_HEIGHT}px)`,
            bgcolor: CONTENT_BG,
            maxWidth: 720,
            mx: 'auto',
        }}>
            <Outlet/>
        </Box>
    );
}

export default AccountContainer;
